import "./ReportsPage.scss";

import { Outlet, Routes, Route, Navigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import useCurrentFilterset from "queries/Reports/Baseline/useCurrentFilterset";
import useFilters from "recoilStore/useFilters";
import MeasuresPage from "pages/MeasuresPage";
import LoadingSpinner from "components/atoms/LoadingSpinner/LoadingSpinner";
import { useCreateReportFilterset } from "mutations/Measures/useCreateReportFiltersetMutation";
import BaselineReport from "./BaselineReport";
import DecarbonizationReport from "./DecarbonizationReport";
import ReportsHeader from "./ReportsHeader";
import ReportsEmptySetWrapper from "./ReportsEmptySetWrapper";

function ReportsLayout() {
    return (
        <div className="reports-page">
            <ReportsHeader />
            <div className="report">
                <ReportsEmptySetWrapper>
                    <Outlet />
                </ReportsEmptySetWrapper>
            </div>
        </div>
    );
}

function Reports() {
    const { filters, setFilters } = useFilters();
    const { isLoading: isCreateFiltersetLoading } = useCreateReportFilterset();
    const { reportedVsPublishedState, selectedFiltersetUid, isLoading: isLoadingFilterset } = useCurrentFilterset();

    const [searchParams] = useSearchParams();

    useEffect(() => {
        const propertyName = searchParams.get("propertyName");
        if (propertyName) {
            const propertyNameFilter: StringFilter = {
                value: [propertyName],
                condition: "equal",
                field: "property_name",
                key: "propertyName",
            };
            setFilters({
                ...filters,
                stringFilters: [propertyNameFilter],
            });
        }
    }, []);

    if (isCreateFiltersetLoading || !selectedFiltersetUid || isLoadingFilterset) {
        return <LoadingSpinner />;
    }

    return (
        <Routes>
            <Route path="/" element={<ReportsLayout />}>
                <Route index element={<Navigate to="baseline" replace />} />
                <Route path="baseline" element={<BaselineReport />} />
                <Route
                    path="outcomes"
                    element={
                        <DecarbonizationReport
                            filtersetUid={selectedFiltersetUid}
                            reportedVsPublished={reportedVsPublishedState}
                        />
                    }
                />
                <Route
                    path="plan"
                    element={
                        <MeasuresPage
                            filtersetUid={selectedFiltersetUid}
                            reportedVsPublished={reportedVsPublishedState}
                        />
                    }
                />
            </Route>
        </Routes>
    );
}
export default Reports;
